import { DefaultService } from '@/services/default'

export class AircraftTypeService extends DefaultService {
  static resourceURL = 'aircraft-type/'
}

export class IATAAirportService extends DefaultService {
  static resourceURL = 'iata-airport/'
}

export class IATACarrierService extends DefaultService {
  static resourceURL = 'iata-carrier/'
}

export class IATACityService extends DefaultService {
  static resourceURL = 'iata-city/'
}

export class IATACountryService extends DefaultService {
  static resourceURL = 'iata-country/'
}

export class IATARegionService extends DefaultService {
  static resourceURL = 'iata-region/'
}
